import Component from '../core/Component'
import Scroll from '../services/Scroll'
import { EVENTS } from '../core/Events'
import EventBus from '../core/EventBus'

export default class ColorSectionObserver extends Component {
    constructor(element, options = {}) {
        super(
            element,
            (options = {
                query: '[data-color-section-observe]',
                offset: () => document.querySelector('.Header')?.offsetHeight ?? 0,
                ...options,
            })
        )

        this.ref = {
            sections: [...document.querySelectorAll(this.options.query)],
        }

        this.sections = []
    }

    prepare() {
        Scroll.on('resize-x', this.handleResize)
        Scroll.on('scroll', this.handleScroll)
        EventBus.on(EVENTS.DOM_CHANGE, this.handleDomChange)
        EventBus.on(EVENTS.SWUP_CONTENT_REPLACED, this.handleSwupContentReplaced)
        this.resize()
        this.update()
    }

    destroy() {
        Scroll.off('resize-x', this.handleResize)
        Scroll.off('scroll', this.handleScroll)
        EventBus.off(EVENTS.DOM_CHANGE, this.handleDomChange)
        EventBus.off(EVENTS.SWUP_CONTENT_REPLACED, this.handleSwupContentReplaced)
        this.detach()
    }

    handleSwupContentReplaced = () => {
        this.clear()
        this.ref.sections = [...document.querySelectorAll(this.options.query)]
        this.resize()
        this.update()
    }

    handleDomChange = () => {
        this.clear()
        this.ref.sections = [...document.querySelectorAll(this.options.query)]
        this.resize()
        this.update()
    }

    handleResize = () => {
        this.resize()
        this.update()
    }

    handleScroll = () => {
        this.update()
    }

    resize() {
        const scrollY = Scroll.getScroll().y

        this.sections = this.ref.sections.map((section) => {
            const rect = section.getBoundingClientRect()
            return {
                element: section,
                color: section.getAttribute('data-color-section-observe') ?? '',
                documentTop: rect.top + scrollY,
                documentBottom: rect.top + rect.height + scrollY
            }
        })

        this.offset = this.options.offset()
    }

    update() {
        if (this.sections.length == 0) {
            return
        }

        const scrollY = Scroll.getScroll().y
        const color = this.sections.find(section => scrollY >= section.documentTop - this.offset && scrollY <= section.documentBottom - this.offset)?.color ?? ''
        document.documentElement.setAttribute('data-color-section', color)
    }

    clear() {
        document.documentElement.setAttribute('data-color-section', '')
    }
}
